import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getFormatedPrice } from '../../../helpers/getFormatedPrice';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Extra } from '../../Common/Extra';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  extensionPole: number | 'no',
  extensionPolePrice: number,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (extensionPole, extensionPolePrice, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      extensionPole,
      extensionPolePrice,
    },
  });
};

export const ExtensionPole = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    extensionPole: extensionPoleAddonProducts,
    custom: { extensionPole },
  } = state.context;

  if (
    isCurrentState('extensionPole', state) &&
    extensionPoleAddonProducts.length === 0
  ) {
    const additionalMessage = `window.extensionPole is empty`;
    throwError(state, additionalMessage);
  }

  return (
    <SectionContent>
      <Heading>Extension pole</Heading>
      <Caption>
        We recommend purchasing an extension pole to operate the blind if you
        are unable to reach the full height of the shade.
      </Caption>
      <Selector>
        {extensionPoleAddonProducts.map(product => {
          const {
            title = '',
            first_available_variant: { id, price },
          } = product;
          return (
            <SelectorItem
              isSelected={extensionPole === id}
              onClick={onClick(id, price, send)}
              key={id}
            >
              {title} <Extra> + {getFormatedPrice(price)} </Extra>
            </SelectorItem>
          );
        })}
        <SelectorItem
          isSelected={extensionPole === 'no'}
          onClick={onClick('no', 0, send)}
          key="no"
        >
          No, thanks
        </SelectorItem>
      </Selector>
    </SectionContent>
  );
};
